import {
  watch
} from "./chunk.HBM5K2JV.js";
import {
  YotpoPriorityTheme,
  YotpoSpacing
} from "./chunk.AREYZEAJ.js";
import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/components/divider/divider.ts
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/components/divider/divider.styles.ts
import { css } from "lit";
var divider_styles_default = css`
	${theme_styles_default}
	${component_styles_default}

	.divider--horizontal {
		border-top: solid 1px; /* 0.0625rem */
		display: block;
		width: 100%;
	}

	.divider--vertical {
		border-left: solid 1px; /* 0.0625rem */
		display: block;
		height: 100%;
	}

	.divider--light-primary {
		border-color: var(--yotpo-color-general-30);
	}

	.divider--light-secondary {
		border-color: var(--yotpo-color-general-10);
	}

	.divider--dark-primary {
		border-color: var(--yotpo-color-white);
		opacity: 20%;
	}

	.divider--dark-secondary {
		border-color: var(--yotpo-color-white);
		opacity: 10%;
	}

	.divider--spacing-none :host {
		margin: 0;
	}

	.divider--horizontal.divider--spacing-small {
		margin: var(--yotpo-spacing-small) 0;
	}

	.divider--horizontal.divider--spacing-medium {
		margin: var(--yotpo-spacing-medium) 0;
	}

	.divider--horizontal.divider--spacing-large {
		margin: var(--yotpo-spacing-x-large) 0;
	}

	.divider--vertical.divider--spacing-small {
		margin: 0 var(--yotpo-spacing-small);
	}

	.divider--vertical.divider--spacing-medium {
		margin: 0 var(--yotpo-spacing-medium);
	}

	.divider--vertical.divider--spacing-large {
		margin: 0 var(--yotpo-spacing-x-large);
	}
`;

// src/components/divider/divider.ts
var YotpoDivider = class extends LitElement {
  constructor() {
    super(...arguments);
    this.color = "light-primary" /* lightPrimary */;
    this.spacing = "none" /* none */;
    this.vertical = false;
  }
  firstUpdated() {
    this.setAttribute("role", "separator");
  }
  handleVerticalChange() {
    this.setAttribute("aria-orientation", this.vertical ? "vertical" : "horizontal");
  }
  render() {
    return html`
			<div
				part="base"
				class=${classMap({
      divider: true,
      "divider--light-primary": this.color === "light-primary" /* lightPrimary */,
      "divider--light-secondary": this.color === "light-secondary" /* lightSecondary */,
      "divider--dark-primary": this.color === "dark-primary" /* darkPrimary */,
      "divider--dark-secondary": this.color === "dark-secondary" /* darkSecondary */,
      "divider--spacing-none": this.spacing === "none" /* none */,
      "divider--spacing-small": this.spacing === "small" /* small */,
      "divider--spacing-medium": this.spacing === "medium" /* medium */,
      "divider--spacing-large": this.spacing === "large" /* large */,
      "divider--horizontal": !this.vertical,
      "divider--vertical": this.vertical
    })}
			></div>
		`;
  }
};
YotpoDivider.componentName = "Divider";
YotpoDivider.styles = divider_styles_default;
__decorateClass([
  property({ type: YotpoPriorityTheme, reflect: true })
], YotpoDivider.prototype, "color", 2);
__decorateClass([
  property({ type: YotpoSpacing, reflect: true })
], YotpoDivider.prototype, "spacing", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoDivider.prototype, "vertical", 2);
__decorateClass([
  watch("vertical")
], YotpoDivider.prototype, "handleVerticalChange", 1);
YotpoDivider = __decorateClass([
  customElement("yotpo-divider")
], YotpoDivider);

export {
  YotpoDivider
};
